export const styles = {
    container: {
        display: ["none", "block"],
    },
    bagContainer: {
        w: "100%",
        p: 6,
        pb: 0,
        bg: "white",
        h: "fit-content",
    },
    header: {
        fontSize: "bodyTextNormal",
        fontWeight: "semibold",
    },
};
